import { render, staticRenderFns } from "./SCardLowInventoyComp.vue?vue&type=template&id=351d1d93&"
import script from "./SCardLowInventoyComp.vue?vue&type=script&lang=js&"
export * from "./SCardLowInventoyComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports